import React from "react";
import CmModal from "../../../../../components/CmModal/CmModal";
import CmForm from "../../../../../components/CmForm/CmForm";
import {Button, Form, Input} from "antd";
import BaseComponent from "../../../../../base/BaseComponent";
import DeptSelectModal from "../deptSelectModal/DeptSelectModal";
import {validateName, validateNumber} from "../../../../../utils";
import {message} from "../../../utils/sysManagementUtils";

export default class DeptAddModal extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            dept: null
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible) {
            const {data, fid} = this.props;
            const params = data || {};
            // 有id 表示修改
            if (!params.id) {
                params.fid = fid;
            }
            this.setState({
                dept: initDept(params)
            });
        }
    }

    render() {
        const {
            dept
        } = this.state;

        if (!dept) {
            return null;
        }

        const {
            title,
            visible
        } = this.props;

        const ifAdd = !dept.id.value;

        const onDeptChange = this.onDeptChange;

        return (
            <>
                <CmModal
                    visible={visible}
                    title={title}
                    handleCancel={this.handleCancel}
                    handleOk={this.handleOk}
                    centered={true}
                >
                    <CmForm onSubmit={this.handleOk}>
                        <Form.Item
                            label={dept.name.label}
                            required={dept.name.required}
                        >
                            <Input
                                placeholder={dept.name.placeholder}
                                value={dept.name.value}
                                onChange={e => onDeptChange({name: e.target.value})}
                            />
                        </Form.Item>
                        <Form.Item
                            label={dept.fid.label}
                            required={dept.fid.required}
                        >
                            <DeptSelectModal
                                title="选择部门"
                                value={dept.fid.value}
                                currentDept={dept.id.value}
                                placeholder={dept.fid.placeholder}
                                handleOk={value => onDeptChange({fid: value})}
                                checkStrictly={true}
                                onItemDelete={() => onDeptChange({fid: ""})}
                            />
                        </Form.Item>
                        <Form.Item
                            label={dept.tel.label}
                            required={dept.tel.required}
                        >
                            <Input
                                placeholder={dept.tel.placeholder}
                                value={dept.tel.value}
                                onChange={e => onDeptChange({tel: e.target.value})}
                            />
                        </Form.Item>
                    </CmForm>
                </CmModal>
            </>
        );
    }

    handleCancel = () => {
        this.props.handleCancel();
    };

    handleOk = () => {
        const {dept} = this.state;
        const data = {};
        const editKeys = Object.keys(dept);
        for (let i = 0; i < editKeys.length; i++) {
            const key = editKeys[i];
            data[key] = dept[key].value;
            if (dept[key].check && !dept[key].check(dept[key].value)) {
                return;
            }
        }
        this.props.handleOk(data);
    };

    onDeptChange = data => {
        const {dept} = this.state;
        const key = Object.keys(data)[0];
        dept[key].value = data[key];
        this.setState({});
    };

}

function initDept(
    {
        id = "",
        name = "",
        tel = "",
        fid = ""
    } = {}
) {
    return {
        fid: {
            value: fid,
            label: "上级部门",
            required: true,
            placeholder: "请选择所属部门",
            check: value => {
                if (!value) {
                    message.error("请选择所属部门！");
                    return false;
                }
                return true;
            }
        },
        id: {
            value: id
        },
        name: {
            value: name,
            label: "部门名称",
            required: true,
            placeholder: "请输入部门名称",
            check: value => {
                if (!value) {
                    message.error("部门名称不能为空！");
                    return false;
                }
                if (!validateName(value, {min: 2, max: 18},'()（）、《》')) {
                    message.error("部门名称为2-18个字，可使用中文、数字、字母、下划线！");
                    return false;
                }
                return true;
            }
        },
        tel: {
            value: tel,
            label: "联系方式",
            placeholder: "请输入联系方式",
            check: value => {
                if (value) {
                    if (!validateNumber(value)) {
                        message.error("联系方式格式错误！");
                        return false;
                    }
                }
                return true;
            }
        },
        status: {
            value: 1
        },
        deptOrder: {
            value: ""
        }
    };
}
